import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Mail, RotateCw } from "lucide-react";
import { toast } from "sonner";
import { fmtDT } from "./shared";

const LABEL = {
  pending: ["In attesa di invio", "text-slate-300"], sending: ["Invio in corso", "text-slate-300"],
  sent: ["Email inviata", "text-emerald-300"], failed: ["Invio fallito", "text-rose-300"],
  not_configured: ["Servizio email non configurato", "text-amber-300"], no_recipient: ["Nessun destinatario configurato", "text-amber-300"],
};

export function NotifyStatus({ checkId, reportId }) {
  const [n, setN] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    try { setN((await api.get("/vehicle-checks/admin/event-notification", { params: checkId ? { check_id: checkId } : { report_id: reportId } })).data); }
    catch { setN({}); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [checkId, reportId]);
  if (!n || !n.id) return null;
  const [label, cls] = LABEL[n.email_status] || [n.email_status, "text-slate-300"];
  const retry = async () => {
    setBusy(true);
    try {
      const r = await api.post(`/vehicle-checks/admin/notifications/${n.id}/retry-email`);
      r.data.status === "sent" ? toast.success("Email inviata") : toast.error(`Invio non riuscito: ${r.data.error || LABEL[r.data.status]?.[0] || r.data.status}`);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false); load();
  };
  return (
    <div className="rounded-lg border border-slate-800 p-2 text-xs space-y-1" data-testid="vc-notify-status">
      <div className="flex items-center justify-between gap-2">
        <span className={`inline-flex items-center gap-1.5 ${cls}`} data-testid="vc-email-status"><Mail size={12} />{label}{n.email_to ? ` · ${n.email_to}` : ""}</span>
        {n.email_status !== "sent" && n.email_status !== "sending" && (
          <button type="button" disabled={busy} onClick={retry} data-testid="vc-email-retry"
            className="inline-flex items-center gap-1 rounded-md border border-amber-500/50 px-2 py-1 text-amber-300 hover:bg-amber-500/10 disabled:opacity-50">
            <RotateCw size={11} className={busy ? "animate-spin" : ""} />Riprova invio
          </button>
        )}
      </div>
      {n.email_error && <div className="text-rose-300/80 break-words" data-testid="vc-email-error">{n.email_error}</div>}
      <div className="text-slate-500">Tentativi: {n.email_attempts || 0}{n.email_updated_at ? ` · ultimo ${fmtDT(n.email_updated_at)}` : ""}</div>
    </div>
  );
}
